import React from 'react';
import Calendar from './Calendar';

const PageHeader = ({ 
  title, 
  showCalendar = true, 
  onDateChange, 
  children,
  className = ""
}) => {
  return (
    <div className={`bg-white mb-4 px-6 py-4 shadow-xl flex flex-wrap gap-3 justify-between items-center ${className}`}>
      <h1 className="text-[#212121] text-2xl font-bold">{title}</h1>
      <div className="flex flex-wrap items-center gap-4">
        {children}
        {showCalendar && <Calendar onDateChange={onDateChange} />}
      </div>
    </div>
  );
};

export default PageHeader; 